import React from 'react';
import {Link} from 'react-router-dom';
import SEO from './SEO';
import segaCennet from '../images/segacennet3.jpg';
import segaIstanbul from '../images/segaist8.jpg';
import segaPlus from '../images/segaplus-2.jpg';
import begonyaPark from '../images/begonyapark.jpg';
import esinApartman from '../images/esinapartman.jpg';
import truvaGol from '../images/truvagolevleri.jpg';
import segaMarin from '../images/segaMarin.png';
import bathonea from '../images/bathonea.png';
import segaCadde from '../images/segaCadde.png';

const REFS = [
	{img: segaCennet, name: 'Sega Cennet', type: 'Site', city: 'İstanbul'},
	{img: segaIstanbul, name: 'Sega İstanbul', type: 'Site', city: 'İstanbul'},
	{img: segaPlus, name: 'Sega Plus', type: 'Site', city: 'İstanbul'},
	{img: begonyaPark, name: 'Begonya Park Evleri', type: 'Site', city: 'İstanbul'},
	{img: esinApartman, name: 'Esin Apartman', type: 'Apartman', city: 'İstanbul'},
	{img: truvaGol, name: 'Truva Göl Evleri', type: 'Site', city: 'İstanbul'},
	{img: bathonea, name: 'Bathonea Residence', type: 'Residence', city: 'İstanbul'},
	{img: segaCadde, name: 'Sega Cadde', type: 'Site', city: 'İstanbul'},
	{img: segaMarin, name: 'Sega Marin', type: 'Site', city: 'İstanbul'},
];

const STATS = [
	{num: REFS.length.toString(), label: 'Aktif proje'},
	{num: '20+', label: 'Yıl tecrübe'},
	{num: '7/24', label: 'Operasyon desteği'},
];

const References = () => {
	return (
		<section className='references'>
			<SEO
				title="Referanslarımız — Yönettiğimiz Projeler · Proteam Yönetim"
				description="İstanbul'da yönettiğimiz site, apartman ve residence projeleri. Sega Cennet, Sega İstanbul, Bathonea Residence, Begonya Park Evleri ve daha fazlası."
				path="/referanslarimiz"
			/>
			<div className='ref-container'>
				<div className='ref-header'>
					<span className='section-eyebrow'>Referanslarımız</span>
					<h1 className='section-title'>Birlikte çalıştığımız projeler</h1>
					<p className='section-lead'>
						Yönettiğimiz site ve apartmanlar ile uzun vadeli çözüm
						ortaklığımız.
					</p>
				</div>

				<div className='ref-stats'>
					{STATS.map((s) => (
						<div className='ref-stat' key={s.label}>
							<div className='ref-stat-num'>{s.num}</div>
							<div className='ref-stat-label'>{s.label}</div>
						</div>
					))}
				</div>

				<div className='grid-container'>
					{REFS.map((r, i) => (
						<article className='grid-item' key={r.name}>
							<span className='ref-number'>{String(i + 1).padStart(2, '0')}</span>
							<img src={r.img} alt={r.name} loading='lazy' decoding='async'/>
							<div className='ref-info'>
								<span className='ref-meta'>
									<i className='fa fa-map-marker' aria-hidden='true'></i>
									{r.city} · {r.type}
								</span>
								<h2>{r.name}</h2>
							</div>
						</article>
					))}
				</div>

				<div className='ref-cta'>
					<div className='ref-cta-text'>
						<h3>Siz de aramıza katılmak ister misiniz?</h3>
						<p>
							Site veya apartmanınız için profesyonel yönetim
							hizmetlerimizden faydalanmak üzere bizimle iletişime
							geçin.
						</p>
					</div>
					<Link to='/iletisim' className='btn btn-primary'>
						Bize ulaşın
					</Link>
				</div>
			</div>
		</section>
	);
};

export default References;
